(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lifeline-purchase"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){
    const link=event.target.closest('[data-lifeline-invoice]');
    if(!link)return;
    const quantity=document.getElementById('Quantity-'+link.dataset.sectionId+'-'+link.dataset.productId);
    const count=Math.max(1,Math.floor(Number(quantity&&quantity.value)||1));
    const url=new URL(link.href,window.location.origin);
    url.searchParams.set('quantity',String(count));
    link.href=url.toString();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["luma-pack-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('luma-pack-picker')) {
    customElements.define('luma-pack-picker', class extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest('product-info') || this.closest('.shopify-section') || this.parentElement;
        this.quantitySelect = this.querySelector('.luma-quantity-select');
        this.templates = Array.from(this.querySelectorAll('template[data-variant]'));
        this.onChange = event => {
          if (event.target === this.quantitySelect) {
            this.updateSelection();
            if (!this.quantitySelect.selectedOptions[0].dataset.current) {
              this.quantitySelect.disabled = true;
              this.setAttribute('aria-busy', 'true');
              window.location.assign(this.quantitySelect.value);
            }
          } else if (event.target.closest('variant-picker') || event.target.name === 'id') {
            this.updateSelection();
          }
        };
        this.productInfo.addEventListener('change', this.onChange);
        this.updateSelection();
        this.querySelector('.luma-picker-row').hidden = false;
      }
      disconnectedCallback() { this.productInfo?.removeEventListener('change', this.onChange); }
      selectedOptions() {
        const currentVariants = this.templates.filter(item => item.dataset.pack === this.dataset.product);
        const controls = Array.from(this.productInfo.querySelectorAll('variant-picker input[type="radio"]:checked, variant-picker select'));
        const variantId = this.productInfo.querySelector('form[action*="/cart/add"] [name="id"]')?.value;
        const currentVariant = currentVariants.find(item => item.dataset.variant === variantId);
        const selected = { colour: currentVariant?.dataset.colour || this.dataset.colour, hub: currentVariant?.dataset.hub || this.dataset.hub };
        for (const option of ['colour', 'hub']) {
          const index = Number(this.dataset[`${option}Index`]);
          if (index > 2) continue;
          const allowed = new Set(currentVariants.map(item => String(JSON.parse(item.dataset.options)[index] || '').trim().toLowerCase()));
          const control = controls.find(item => allowed.has(item.value.trim().toLowerCase()));
          if (control) selected[option] = control.value.trim().toLowerCase();
        }
        return selected;
      }
      updateSelection() {
        const selected = this.selectedOptions();
        const preview = new URL(window.location.href).searchParams.get('preview_theme_id') || this.dataset.previewTheme;
        Array.from(this.quantitySelect.options).forEach(option => {
          const template = this.templates.find(item => item.dataset.pack === option.dataset.pack && item.dataset.colour === selected.colour && item.dataset.hub === selected.hub);
          const url = new URL(option.value, window.location.origin);
          if (template) {
            url.searchParams.set('variant', template.dataset.variant);
            if (option.dataset.current) this.querySelector('.luma-pack-summary').replaceChildren(template.content.cloneNode(true));
          }
          if (preview) url.searchParams.set('preview_theme_id', preview);
          option.value = url.pathname + url.search;
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["xsense-pack-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('xsense-pack-picker')) {
    customElements.define('xsense-pack-picker', class extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest('product-info');
        this.quantitySelect = this.querySelector('.xsense-quantity-select');
        this.onChange = event => {
          if (event.target === this.quantitySelect) {
            if (!this.quantitySelect.selectedOptions[0].dataset.current) {
              this.quantitySelect.disabled = true;
              this.setAttribute('aria-busy', 'true');
              window.location.assign(this.quantitySelect.value);
            }
          } else if (event.target.closest('variant-picker')) {
            this.updateSelection();
          }
        };
        this.productInfo?.addEventListener('change', this.onChange);
        this.updateSelection();
        this.querySelector('.xsense-picker-row').hidden = false;
      }
      disconnectedCallback() { this.productInfo?.removeEventListener('change', this.onChange); }
      updateSelection() {
        const selected = this.productInfo?.querySelector('variant-picker input[type="radio"]:checked, variant-picker select');
        const title = selected?.value || 'Default Title';
        const template = Array.from(this.querySelectorAll('template')).find(item => item.dataset.xsenseOption === title);
        if (template) this.querySelector('.xsense-pack-summary').replaceChildren(template.content.cloneNode(true));
        Array.from(this.quantitySelect.options).forEach(option => {
          const url = new URL(option.value, window.location.origin);
          url.searchParams.set('variant', title === 'Med HUB' ? option.dataset.with : option.dataset.without);
          const preview = this.dataset.previewTheme || new URL(window.location.href).searchParams.get('preview_theme_id');
          if (preview) url.searchParams.set('preview_theme_id', preview);
          option.value = url.pathname + url.search;
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
